<template>
  <div class="bodys">
     <div style="    position: fixed;
    top: 120px;
    font-size: 36px;
    color: red;
    font-weight: 900;
    font-weight: bolder;
    letter-spacing: 2px;">
      <h1 style="font-weight: 600;">本系统为互联网非涉密系统，禁止处理国家秘密及工作秘密信息</h1>
    </div>
    <transition name="el-fade-in-linear">
      <div class="contentsa" v-show="dlshow">
        <div class="yglogo">
          <!--<img src="../common/images/yunglog.png" alt="" />-->
        </div>
        <div class="contentsq">
          <h6 class="titles">淤地坝管理信息系统</h6>
          <div class="nameicon">
            <transition name="el-fade-in-linear">
              <span v-show="userimg" class="nameicon1 ">
                <!-- <img src="../common/images/duihao.png" style="height: 22px;" />-->
              </span>
            </transition>
            <input style="color: #343434;text-align: center;" @focus="focusa()" @blur="blura()" type="text" v-model.trim="username" AUTOCOMPLETE="off" class="username" placeholder="请输入用户名" />
          </div>
          <div class="passicon">
            <transition name="el-fade-in-linear">
              <span v-show="passimg" class=" pswdicon1">
                <!--<img src="../common/images/duihao.png" style="height: 22px;" />-->
              </span>
            </transition>
            <input style="color: #343434;text-align: center;" @focus="focusb()" @blur="blurb()" type="password" placeholder="请输入密码" autocomplete="new-password" class="username userpass" v-model.trim="passwords" />
          </div>

          <div style="margin-top: 10px;">
            <el-select v-model="leix" placeholder="页面类型" style="width: 80%; margin-left: 10%;" class="project-select">
              <el-option v-for="item in leixlist" :key="item.href" :label="item.name" :value="item.href">
              </el-option>
            </el-select>
          </div>

          <el-popover placement="left" width="200" height="200" trigger="click">
            <div id="qrCode" ref="qrCodeDiv"></div>
            <p style="height: 25px;line-height: 25px;font-size: 14px;text-align: center;font-weight: bold;">扫描二维码，下载淤地坝APP</p>
            <img class="appbutton" src="../common/images/applogo.png" slot="reference" />
          </el-popover>

          <div class="btnst btnstatic">
            <button @click="resetting()">重置密码</button>
            <button v-if="logings" @click="login()">登 录</button>
            <div class="btnsta" v-if="logings==false">
              <!--<div id="xuanzhun" style="width: 30px; height: 30px;"></div>-->
              <div class="el-icon-loading" style="font-size: 27px;color:#9bf2fa;"></div>
            </div>
          </div>

          <el-dialog title="重置密码" :append-to-body="true" :visible.sync="dialogVisible" width="25%" top="17%" :before-close="handleClose" :close-on-click-modal="false">
            <el-form ref="form" :model="form" label-width="80px">
              <div class="dialog-content">
                <el-form-item label="用户名">
                  <el-input v-model="form.userName"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                  <el-input v-model="form.mobilePhone"></el-input>
                </el-form-item>
              </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="onSubmit">确 定</el-button>
            </span>
          </el-dialog>

        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { login, passwordResetVerify } from '@/api/api.js'
import QRCode from 'qrcodejs2';

export default {
  data() {
    return {
      username: '',
      passwords: '',
      dlshow: false,
      timer: null,
      userimg: false,
      passimg: false,
      logings: true,
      dialogVisible: false,
      form: {
        userName: '',
        mobilePhone: ''
      },
      leixlist: [
        { name: '驾驶舱', href: 'indexpage' },
        { name: '业务系统', href: 'datamanagement' }
      ],
      //leix: 'datamanagement',
      leix: 'indexpage',
      code:'',//第三方跳转单点登录
      sourceIP:'',
      sourcePORT:''
    };
  },
  created() {
    if(this.$route.query && this.$route.query.code){
      this.code = this.$route.query.code;
      this.sourceIP = this.$route.query.sourceIP;
      this.sourcePORT = this.$route.query.sourcePORT;
      this.login();
    }
  },
  methods: {
    login() {
      this.logings = false;
      if(!this.code){
        if (this.leix == '') {
        this.$notify({
          title: "提示",
          message: '请选择页面类型',
          type: "warning"
        });
        this.logings = true;
      } else if (this.username == '') {
        this.$notify({
          title: "提示",
          message: '请输入用户名',
          type: "warning"
        });
        this.logings = true;
      } else if (this.passwords == '') {
        this.$notify({
          title: "提示",
          message: '请输入密码',
          type: "warning"
        });
        this.logings = true;
      }
        // if (this.username == '') {
        //   this.$notify({
        //     title: "提示",
        //     message: '请输入用户名',
        //     type: "warning"
        //   });
        //   this.logings = true;
        //   return;
        // } else if (this.passwords == '') {
        //   this.$notify({
        //     title: "提示",
        //     message: '请输入密码',
        //     type: "warning"
        //   });
        //   this.logings = true;
        //   return;
        // }

      }
      let params = {
          username: this.username,
          password: this.passwords,
          code:this.code,
          sourceIP: this.sourceIP,
          sourcePORT: this.sourcePORT
        }
        login(params).then((res) => {
          // console.log(res)
          document.onkeydown = undefined;
          this.logings = true;
          if (res.code == '500') {
            if (res.data && res.data.userLoginLimit.remainingLockTime == -1) {
              this.$message.error(res.message + '，五分钟内输错十次该账户将被锁定五分钟，您已经输错' + res.data.userLoginLimit.userErrorCount + '次！');
            } else  if (res.data && res.data.userLoginLimit.remainingLockTime != -1){
              this.$message.error(res.message + '，您还有' + res.data.userLoginLimit.remainingLockTime + '秒解除锁定');
            }else{
              this.$message.error(res.message)
            }
            
          } else {
            //获取当前用户省市县类型
            let regionCode = res.data.regionCode;
            let type = 0;
            if (regionCode == '' || (regionCode[2] == '0' && regionCode[3] == '0' && regionCode[4] == '0' && regionCode[5] == '0')) {
              type = 0;
            } else if (regionCode[4] == '0' && regionCode[5] == '0') {
              type = 1;
            } else {
              type = 2;
            }

            this.$store.commit('toKen', res.token); //token
            this.$store.commit('userId', res.data.id); //用户id
            this.$store.commit('naMe', res.data.username); //用户名
            // this.$store.commit('unIt', res.data.unit); //用户单位
            this.$store.commit('unIt', this.passwords); //用户密码
            this.$store.commit('Tel', res.data.tel); //用户电话
            this.$store.commit('Type', type); //用户省市县类型
            this.$store.commit('RoleCode', res.data.roleCodes); //角色code
            this.$store.commit('RegionCode', res.data.regionCode); //角色code

            localStorage.setItem('toKen', res.token);
            localStorage.setItem('userId', res.data.id);
            localStorage.setItem('naMe', res.data.username);
            // localStorage.setItem('unIt',res.data.unit);
            localStorage.setItem('unIt', this.passwords);
            localStorage.setItem('Tel', res.data.tel);
            localStorage.setItem('RoleCode', res.data.roleCodes);
            localStorage.setItem('RegionCode', res.data.regionCode);
            localStorage.setItem('onlyCockpit', res.data.onlyCockpit);//true是单点登录
            this.leix =  this.code ? 'indexpage' : this.leix;
            this.$router.replace(this.leix)
          }
        })

    },
    resetting() {
      this.dialogVisible = true;
    },
    handleClose(done) {
      this.form.userName = ''
      this.form.mobilePhone = ''
      //   done();
      this.dialogVisible = false
    },
    onSubmit() {
      console.log('submit!', this.form);
      if (this.form.userName == '') {
        this.$notify({
          title: "提示",
          message: '请输入用户名',
          type: "warning"
        });
      } else if (this.form.mobilePhone == '') {
        this.$notify({
          title: "提示",
          message: '请输入手机号',
          type: "warning"
        });
      } else {
        passwordResetVerify(this.form).then(res => {
          if (res.code == 200) {
            this.$notify({
              title: "提示",
              message: "重置成功",
              type: "success"
            });
            this.dialogVisible = false
          } else if (res.code == 500) {
            this.$notify({
              title: "提示",
              message: res.message,
              type: "error"
            });
          }
        })
      }
    },
    focusa() {
      this.userimg = false;
    },
    blura() {
      if (this.username == "") {

      } else {
        this.userimg = true;
      }

    },
    focusb() {
      this.passimg = false;
    },
    blurb() {
      if (this.passwords == "") {

      } else {
        this.passimg = true;
      }
    },
    //二维码方法
    bindQRCode() {
      new QRCode(this.$refs.qrCodeDiv, {
        text: 'http://111.21.216.203:10004/apk/ydb.apk',
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        // correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    },
  },
  mounted() {
    var _self = this;
    document.onkeydown = function (e) {

      let keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        _self.login();

      }
    }
    this.timer = setTimeout(function () {
      _self.dlshow = true;
    }, 600)
    this.$nextTick(function () {
      this.bindQRCode();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
</script>

<style scoped="scoped">
.btnsta {
  /* display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #16b1c5;
  border: none;
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 4px;
*/
  width: 48%;
  background: #66b1ff;
  border: none;
  text-align: center;
  cursor: pointer;
  height: 40px;
  line-height: 50px;
  color: #fff;
  border-radius: 4px;
  margin-left: 4%;
}

#xuanzhun {
  -webkit-transition-property: -webkit-transform;
  -webkit-transition-duration: 1s;
  -moz-transition-property: -moz-transform;
  -moz-transition-duration: 1s;
  -webkit-animation: rotate 1s linear infinite;
  -moz-animation: rotate 1s linear infinite;
  -o-animation: rotate 1s linear infinite;
  animation: rotate 1s linear infinite;
  background: #ccc;
}

@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}

@-o-keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}

.bodys {
  width: 100%;
  height: 100vh;
  background: url(../common/images/loginPic.png) no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentsa {
  width: 420px;
  height: 500px;
  position: absolute;
  /* left: 0px; */
  right: 0px;
  top: 0px;
  right: 15%;
  bottom: 0px;
  margin: auto;
}

.contentsq {
  width: 420px;
  height: 402px;
  background: #fff;
  opacity: 0.8;
  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
}

.titles {
  width: 100%;
  height: 130px;
  line-height: 130px;
  color: #333333;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
}

.nameicon {
  width: 80%;
  height: 40px;
  margin-left: 10%;
  position: relative;
  /*border-image-source: url();*/
  border-bottom: 1px solid #ccc;
}

.passicon {
  width: 80%;
  height: 40px;
  margin-left: 10%;
  position: relative;
  margin-top: 20px;
  border-bottom: 1px solid #ccc;
}

.nameicon1 {
  position: absolute;
  right: 1%;
  top: 5px;
  color: #ccc;
  z-index: 1;
  font-size: 20px;
  line-height: 40px;
  width: 30px;
  height: 30px;
  display: block;
}

.pswdicon1 {
  position: absolute;
  right: 1%;
  top: 5px;
  color: #ccc;
  z-index: 1;
  font-size: 20px;
  line-height: 40px;
  width: 30px;
  height: 30px;
  display: block;
}

.username {
  width: calc(100% - 40px);
  height: 40px;
  border: none;
  font-size: 14px;
  border-bottom: 1px solid #16b1c5;
  margin: 0 auto;
  display: block;
}

.yglogo {
  display: block;
  width: 420px;
  height: 80px;
}

.yglogo img {
  width: 100%;
}

.username input {
  padding-left: 40px;
}

.el-input__inner {
}

.appbutton {
  float: left;
  height: 40px;
  margin-top: 60px;
  margin-left: 10%;
  cursor: pointer;
}

.btnst {
  float: right;
  margin-top: 60px;
  width: 60%;
  margin-right: 10%;
  display: flex;
}

.btnst button {
  width: 100%;
  background: #16b1c5;
  border: none;
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  color: #fff;
  border-radius: 4px;
}

.btnstatic button {
  width: 48%;
}

.btnstatic button:nth-child(2) {
  margin-left: 4%;
  background: #66b1ff;
}

.dialog-content {
  height: 200px;
}

.dialog-footer button {
  width: 100px;
  height: 40px;
  background: #1abc9c;
}

.el-button {
  width: 100%;
  background: #1abc9c;
  border: none;
}

.tisi {
  margin-top: 20px;
  width: 80%;
  margin-left: 10%;
  display: none;
}

::v-deep .el-dialog {
  opacity: 0.8;
}
::v-deep .el-dialog__header {
  padding: 10px 20px 10px;
}
::v-deep .el-dialog__title {
  line-height: 24px;
  font-size: 18px;
  color: #303133;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #909399;
}
::v-deep .el-dialog__body {
  padding: 10px 20px;
  overflow: auto;
  background: #fff;
  margin-left: 16px;
  margin-right: 16px;
  border-radius: 10px 10px 0px 0px;
}

::v-deep .el-dialog__footer {
  margin-left: 16px;
  margin-right: 16px;
  border-radius: 0px 0px 10px 10px;
  background: #fff;
  padding: 10px 20px;
  text-align: center;
}

.tisi p {
  font-size: 14px;
  color: #f00;
}
</style>
